import { Component, Input, OnInit } from '@angular/core';
import { ApiService, 
  AppHelper,
         AppStatic } from '../../_core';
// import { Entry } from 'contentful';

import { MatSnackBar } from '@angular/material/snack-bar';

import { isDevMode } from '@angular/core'

// import { faBars } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'lcp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input('isInverted') isInverted: boolean = false

  navItems: any

  // faBars = faBars

  shouldShowMenu: boolean = false
  year: number = new Date().getFullYear()

  // currentUser$: any
  isLoggedIn: boolean
  isAdmin: boolean
  isDevMode = isDevMode()
  isAdminPage: boolean

  fields = {
    facebook_url: 'https://www.facebook.com/oakparkcleaners/',
    nextdoor_url: 'https://nextdoor.com/pages/oak-park-cleaners-pleasant-hill-ca-1/',
    yelp_url: 'https://www.yelp.com/biz/oak-park-cleaners-pleasant-hill'
  }
  addressLine1: string
  addressLine2: string
  phoneNumber: string

  paginationOptions = this.appHelper.defaultPaginationOptions()
  limit = this.paginationOptions.limit
  page = this.paginationOptions.page
  sortBy = this.paginationOptions.sortBy
  total: number

  gotSettings: boolean

  constructor(
    protected apiService: ApiService,
    protected appHelper: AppHelper,
    // protected authService: AuthService,
    // private matSnackbar: MatSnackBar,
    // private settingService: SettingService
  ) { }

  ngOnInit(): void {
    // this.currentUser$ = this.currentUserStream()
    this.updateSettings()
    this.update()
  }

  updateSettings() {
    let params = { 
      limit: this.limit, 
      page: this.page, 
      sortBy: this.sortBy
    }
    this.getSettings(params)
  }

  getSettings(params) {
    // console.log('TODO: footer - getSettings?', params)
    
    // this.settingService.findSettingBy({ name: 'phone_number' }).then(setting => {
    //   this.phoneNumber = setting.value
    // })

    // this.settingService.getSettings(params).then(settings => {
    //   // console.log('SETTINGS', settings)
    //   if (!settings) return 
    //   for (let setting of settings['results']) {
    //     if (setting.name == 'phone_number') this.phoneNumber = setting.value
    //     if (setting.name == 'address_line_1') this.addressLine1 = setting.value
    //     if (setting.name == 'address_line_2') this.addressLine2 = setting.value
    //   }
    //   // this.gotSettings = true
    //   // this.detectChanges()
    // })
  }

  update() {
    this.year = new Date().getFullYear()
    if (!AppStatic.isBrowser) return
    let splt = window.location.pathname.split('/')
    // let path = splt[1]
    // console.log('ADMIN?', splt, splt.indexOf('admin'))
    this.isAdminPage = splt.indexOf('admin') > -1
    this.year = new Date().getFullYear()
  }

  // currentUserStream() {
  //   return this.authService.currentUser.subscribe( (u:User) => {
  //     u = u as User
  //     this.isLoggedIn = u != null
  //     if (!u) return
  //     this.isAdmin = u ? u.isRole('admin') : false
  //     // console.log('curu', this.isLoggedIn, this.isAdmin, u)
  //   })
  // }

  handleSelectContact(evt: any) {
    // window.scrollTo(0,0)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }



  // getMainNavItems() {
  //   this.contentService.getMainNavItems()
  //   .subscribe({
  //     next: (navItems) => {
  //       let results = navItems.items
  //       this.navItems = results[0].fields['items']
  //       console.log('navItems:', this.navItems)
  //     }
  //  })
  // }

  
}
